import { api } from './api';

export interface AuditLog {
  id: string;
  userId: string;
  action: string;
  entity: string;
  entityId?: string;
  details?: any;
  metadata?: any;
  locationId?: string;
  createdAt: string;
  user: {
    id: string;
    name: string;
    email: string;
    role: string;
  };
  location?: {
    id: string;
    name: string;
  };
}

export interface AuditLogsResponse {
  success: boolean;
  data: AuditLog[];
  pagination: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
    hasNext: boolean;
    hasPrev: boolean;
  };
}

export interface AuditLogFilters {
  userId?: string;
  entity?: string;
  action?: string;
  entityId?: string;
  locationId?: string;
  startDate?: string;
  endDate?: string;
  page?: number;
  limit?: number;
}

export interface AuditLogActionsResponse {
  success: boolean;
  data: {
    actions: { value: string; label: string }[];
    entities: { value: string; label: string }[];
  };
}

export interface UserActivitySummaryResponse {
  success: boolean;
  data: {
    userId: string;
    period: string;
    totalActions: number;
    summary: Record<string, number>;
    recentActivity: AuditLog[];
  };
}

export const auditLogApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAuditLogs: builder.query<AuditLogsResponse, AuditLogFilters>({
      query: (filters = {}) => {
        const searchParams = new URLSearchParams();
        
        Object.entries(filters).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== '') {
            searchParams.append(key, value.toString());
          }
        });
        
        return {
          url: `/audit-logs?${searchParams.toString()}`,
          method: 'GET',
        };
      },
      providesTags: ['AuditLog'],
    }),
    
    getAuditLogActions: builder.query<AuditLogActionsResponse, void>({
      query: () => ({
        url: '/audit-logs/actions',
        method: 'GET',
      }),
      providesTags: ['AuditLog'],
    }),
    
    getUserActivitySummary: builder.query<UserActivitySummaryResponse, { userId: string; days?: number }>({
      query: ({ userId, days = 30 }) => ({
        url: `/audit-logs/user/${userId}/summary?days=${days}`,
        method: 'GET',
      }),
      providesTags: ['AuditLog'],
    }),
  }),
});

export const {
  useGetAuditLogsQuery,
  useGetAuditLogActionsQuery,
  useGetUserActivitySummaryQuery,
} = auditLogApi;